export const GET_AD_GROUP_AD="GET_AD_GROUP_AD"
export const GET_AD_GROUP_AD_SUCCESS="GET_AD_GROUP_AD_SUCCESS"
export const GET_AD_GROUP_AD_ERROR="GET_AD_GROUP_AD_ERROR"

export const CREATE_AD_GROUP_AD="CREATE_AD_GROUP_AD"
export const CREATE_AD_GROUP_AD_SUCCESS="CREATE_AD_GROUP_AD_SUCCESS"
export const CREATE_AD_GROUP_AD_ERROR="CREATE_AD_GROUP_AD_ERROR"

export const UPDATE_AD_GROUP_AD="UPDATE_AD_GROUP_AD"
export const UPDATE_AD_GROUP_AD_SUCCESS="UPDATE_AD_GROUP_AD_SUCCESS"
export const UPDATE_AD_GROUP_AD_ERROR="UPDATE_AD_GROUP_AD_ERROR"

export const DELETE_AD_GROUP_AD="DELETE_AD_GROUP_AD"
export const DELETE_AD_GROUP_AD_SUCCESS="DELETE_AD_GROUP_AD_SUCCESS"
export const DELETE_AD_GROUP_AD_ERROR="DELETE_AD_GROUP_AD_ERROR"